import sessionStorageService from "./sessionStorage.service";

// Spec 000306 - the driver proof returned by a correct SMS code. It lives in this tab only (sessionStorage),
// survives the redirect to the clearing page and back, and is gone when the tab closes.
const DRIVER_SESSION_KEY = "driverSession";
const DRIVER_SESSION_EXPIRED_KEY = "driverSessionExpired";

const get = () => sessionStorageService.getItem(DRIVER_SESSION_KEY);

const set = (driverSession) => sessionStorageService.setItem(DRIVER_SESSION_KEY, driverSession);

const clear = () => sessionStorageService.removeItem(DRIVER_SESSION_KEY);

// Set when the server refused an expired proof, read once by the phone step to explain why it is back there.
const markExpired = () => sessionStorageService.setItem(DRIVER_SESSION_EXPIRED_KEY, true);

const consumeExpired = () => {
  const expired = sessionStorageService.getItem(DRIVER_SESSION_EXPIRED_KEY) === true;
  sessionStorageService.removeItem(DRIVER_SESSION_EXPIRED_KEY);
  return expired;
};

const driverSessionService = { get, set, clear, markExpired, consumeExpired };

export default driverSessionService;
